// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { endPoints } from '../../apis/apiEndPoints';
import { extractDomain } from '../../utils/helpers';


// Define a service using a base URL and expected endpoints
const DOMAIN = extractDomain();

export const eventTracking = createApi({
    reducerPath: 'eventTracking',
    baseQuery: fetchBaseQuery({
        //baseUrl:'https://recruiter.foundit.in'
     baseUrl: window.location.origin
    }),
    endpoints: (builder) => ({

        postEventTracking: builder.mutation({
            query: (payload) => ({
                url: endPoints.EVENT_TRACKING,
                method: 'POST',
                body: payload,
                headers: {
                    'domain': DOMAIN,
                },
                withCredentials: true
            })
        })
    }),
})

export const {
   usePostEventTrackingMutation
} = eventTracking;

export const eventTrackingData = eventTracking.endpoints.postEventTracking;